import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { syncServerClock } from './utils/serverClock';

// One server-time fetch per page load, for the display clocks (see utils/serverClock.ts).
// Not awaited: the page renders immediately on the local clock and corrects when it lands.
void syncServerClock();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);